import SubscriptionsList from "./SubscriptionsList";

export default SubscriptionsList;
